import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import AppTextColumnDetails from '../../../details/general-details/AppTextColumnDetails'

const AppModalDetails = ({
  companyBankAccountDetails,
}) => {
  return (
    <>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Account Name"
          subtitle={companyBankAccountDetails?.account_name ? companyBankAccountDetails?.account_name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Account Number"
          subtitle={companyBankAccountDetails?.account_number ? companyBankAccountDetails?.account_number : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Account Swift Code"
          subtitle={companyBankAccountDetails?.account_swift_code ? companyBankAccountDetails?.account_swift_code : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Bank Name"
          subtitle={companyBankAccountDetails?.bank_name ? companyBankAccountDetails?.bank_name : '-'}
        />
        <AppTextColumnDetails
          colSize="6"
          className='mb-3'
          title="Bank Address"
          subtitle={companyBankAccountDetails?.bank_address ? companyBankAccountDetails?.bank_address : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Default Bank?"
          subtitle={companyBankAccountDetails?.is_default_bank === 'Yes' || companyBankAccountDetails?.is_default_bank === true ? 'Yes' : 'No'}
        />
      </CRow>
    </>
  )
}

export default AppModalDetails
